import { giphyBlack } from '@giphy/colors'
import { CloseButton } from './style'

type Props = {
    className?: string
    onClick?: () => void
}

const UGECloseButton = ({ className, onClick }: Props) => {
    return <CloseButton className={className} color={giphyBlack} icon="close" size="large" onClick={onClick} />
}

export default UGECloseButton
